const themeToggleButton = document.querySelector('.js-theme-toggle');

if (themeToggleButton) {
    themeToggleButton.addEventListener('click', function () {
        fetch(`/api/theme/toggle`, {
            method: 'GET'
        })
            .then(response => {
                if (response.ok) {
                    window.location.reload();
                } else {
                    console.error('Failed to toggle theme');
                }
            })
            .catch(error => console.error('Error:', error));
    });
}